import React 								from 'react';

import {DeviceType}							from '../typescript-declaration/global';

import img_computer							from '../images/devices/catalog-computer.png';
import img_tablet							from '../images/devices/catalog-tablet.png';
import img_phone							from '../images/devices/catalog-phone.png';
import img_screen							from '../images/devices/catalog-screen.png';
import img_mouse							from '../images/devices/catalog-mouse.png';
import img_headphones						from '../images/devices/catalog-headphone.png';
import img_speaker							from '../images/devices/catalog-speaker.png';
import img_hub								from '../images/devices/catalog-hub.png';
import img_keyboard							from '../images/devices/catalog-keyboard.png';
import img_sim								from '../images/devices/catalog-sim.png';

function renderData(name: DeviceType, image: string) {
	return {
		value:  name,
		render: <img src={image} alt={name} height={38} />
	};
}

export const BUTTON_GROUP_DATA = [
	renderData('computer', img_computer),
	renderData('tablet', img_tablet),
	renderData('phone', img_phone),
	renderData('screen', img_screen),
	renderData('mouse', img_mouse),
	renderData('headphones', img_headphones),
	renderData('speaker', img_speaker),
	renderData('hub', img_hub),
	renderData('keyboard', img_keyboard),
	renderData('sim', img_sim)
];